export default __webpack_public_path__ + "static/media/EVEN_BG.50249dca.png";